import { Link, useRouteError } from 'react-router-dom';
import { getErrorMessage } from '../utils/errorUtils';

const SANTTAI_LOGO_URL =
  'https://imagedelivery.net/KQLaZdBjDzxarhwBRuqRFg/33a0d3dd-4713-44fc-2792-1237db489400/public';

export default function ErrorBoundary() {
  const error = useRouteError();
  const errorMessage = getErrorMessage(error);

  if (import.meta.env.DEV) {
    console.error('ErrorBoundary caught error:', error);
  }

  const handleTryAgain = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen flex-col bg-neutral-20 font-manrope text-neutral-800">
      <header className="border-b border-neutral-100 bg-neutral-00 px-6 py-4 lg:px-36">
        <Link to="/" aria-label="Santtai home" className="inline-flex shrink-0">
          <img
            className="h-8 w-[120px] object-contain"
            src={SANTTAI_LOGO_URL}
            alt="Santtai"
            width={120}
            height={32}
          />
        </Link>
      </header>

      <main className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="w-full max-w-lg rounded-2xl border border-neutral-100 bg-neutral-00 p-8 shadow-m">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-santtai-primary">
            Santtai
          </p>
          <h1 className="mt-2 font-dm-serif text-3xl leading-tight text-santtai-900">
            Something went wrong
          </h1>
          <p className="mt-3 text-base leading-normal text-neutral-300">
            We&apos;re having trouble loading this page. You can try again, go
            back to Trip Management, or return home.
          </p>

          {import.meta.env.DEV && (
            <p className="mt-4 rounded-lg bg-red-100 px-3 py-2 font-mono text-sm text-status-error">
              {errorMessage}
            </p>
          )}

          <div className="mt-8 flex flex-col gap-3">
            <button
              type="button"
              onClick={handleTryAgain}
              className="flex w-full items-center justify-center rounded-lg bg-gradient-to-r from-brand-santtai-primary to-brand-santtai-primary-darker px-6 py-4 text-base font-semibold text-neutral-00"
              aria-label="Try again"
              tabIndex={0}
            >
              Try again
            </button>

            <Link
              to="/app/tripmanagement"
              className="flex w-full items-center justify-center rounded-lg border border-brand-santtai-primary px-6 py-4 text-base font-semibold text-brand-santtai-primary"
              aria-label="Back to Trip Management"
              tabIndex={0}
            >
              Back to Trip Management
            </Link>

            <Link
              to="/"
              className="flex w-full items-center justify-center rounded-lg px-6 py-3 text-base font-semibold text-neutral-300 underline-offset-2 hover:underline"
              aria-label="Home"
              tabIndex={0}
            >
              Home
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
